import React from "react";
import { Box } from "@material-ui/core";

export default function TermsContent() {
  return (
    <Box mb={4}>
      <p>
        These Terms of Use ("<u>Terms</u>") govern the relationship between you
        ("<u>you</u>" or "<u>User</u>") and Integrity Music, a division of David
        C Cook, and its affiliates or subsidiaries (collectively referred to in
        these Terms as "<u>we</u>" or "<u>Integrity</u>") concerning the
        Integrity Music Licensing Website and its related services
        (collectively, the "<u>Site</u>"). By using or accessing this Site, you
        agree to these Terms, as updated from time to time (provided only those
        Terms to which you have agreed or are applicable at the time of your
        visit and/or use will govern). If you are agreeing to these Terms for
        use by a business (e.g., a corporation) or other organization, you are
        agreeing to these Terms on behalf of that organization, and such
        organization accepts these Terms. In such case, "you" or "User" as used
        herein refers to the organization you represent. You must have authority
        to bind that organization to this Agreement; otherwise you must not sign
        up for or otherwise make use of the Site. The Site provides a varying
        range of services, which may require that you review and accept
        supplemental terms that apply to your use of the Site. To the extent
        those supplemental terms conflict with these Terms, the supplemental
        terms govern.
      </p>
      <Box fontSize="h6.fontSize" fontWeight="bold">
        1. License and Description of Services
      </Box>
      <p>
        Subject to your compliance with these Terms, Integrity grants to you a
        non-exclusive license to access the Site, which may include a variety of
        services and resources, including without limitation confidential
        agreements provided by Integrity. By using the Site, you agree to
        receive certain communications from Integrity, including without
        limitation service announcements, administrative messages, and other
        messages which Integrity may disseminate from time to time related to
        the Site.{" "}
        <b>
          You agree and understand that the terms of any license or agreement
          offered to you from Integrity via the Site or otherwise shall be
          considered confidential and proprietary information of Integrity, and
          except as set forth herein, you shall not share the license or
          agreement, or any of the terms of same, with any third party without
          Integrity’s prior written consent.
        </b>
      </p>
      <Box fontSize="h6.fontSize" fontWeight="bold">
        2. Privacy and Submission of Data to Integrity
      </Box>
      <p>
        Any information that you submit to Integrity is governed by the
        Integrity{" "}
        <a href="https://davidccook.org/privacy-policy/" target="_new">
          Privacy Policy
        </a>
        , which is incorporated herein. Certain functions and services offered
        through the Site may be provided by a third party in which case those
        third parties’ privacy policies may also apply where indicated. You
        acknowledge and agree that Integrity has no control over and is not
        responsible for the privacy practices of any third party. Additionally,
        by using the Site, you acknowledge and agree that internet transmissions
        are never completely private or secure. You understand that any message
        or information you send to the Site may be read or intercepted by
        others, even if there is a special notice that a particular transmission
        (for example, credit card information) is encrypted.
      </p>
      <Box fontSize="h6.fontSize" fontWeight="bold">
        3. Account Registration
      </Box>
      <p>
        For use of the Site or certain services you may be asked to create an
        account by providing Integrity with current and accurate personal
        information as prompted by the registration form. It is a condition of
        your use of the Site that all the information you provide on the Site is
        correct, current, and complete. By establishing an account, you
        represent and warrant you have the right and are authorized to provide
        to us the information you provide when you register for such an account.
        You are solely responsible for maintaining the confidentiality of your
        name and password and for any activity which occurs under your account.
        You agree that your account is personal to you and that you will notify
        Integrity as soon as reasonably possible if you become aware of
        unauthorized use of your account or other security breach. Integrity
        will not be liable for any loss that you may incur as a result of a
        third party accessing or using your account, either with or without your
        knowledge. If you create an account with Integrity directly through the
        Site, your account status is subject to compliance with these Terms.
      </p>
      <p>
        Without limitation of the foregoing, you may not use a user name or
        email address that belongs to or is already being used by another
        person; that may be construed as impersonating another person; that
        violates the intellectual property or other rights of any person; that
        is offensive; or that we reject for any other reason in our sole
        discretion.
      </p>
      <Box fontSize="h6.fontSize" fontWeight="bold">
        4. Integrity Content
      </Box>
      <p>
        All text, graphics, images, music, video, audio, text, animation,
        widgets, user interfaces, trademarks, logos, software code, and other
        copyrighted or otherwise proprietary content (collectively, "Content"),
        including but not limited to the design, structure, selection,
        coordination, expression, and arrangement of such Content, contained on
        or within the Site is owned, controlled, or licensed by or to Integrity,
        and is protected by trade dress, copyright, and trademark laws, and
        various other intellectual property rights and unfair competition laws.
      </p>
      <p>
        Except as expressly provided in these Terms or in a separate license
        agreement you may enter into with Integrity, no part of the Site,
        including Content contained therein, may be copied, reproduced,
        republished, uploaded, posted, publicly displayed, encoded, translated,
        transmitted, or distributed in any way to any other computer, server,
        website, or other medium for publication, distribution, or for any
        enterprise (commercial or non-commercial), without Integrity’s express
        prior written consent. Your use of the Site is limited to the uses for
        which it is intended.
      </p>
      <p>
        You may use information purposely made available by Integrity for
        downloading (or other form of distribution) from the Site, provided that
        you: (1) not remove any proprietary notice language in all copies of
        such documents; (2) use such information only for your personal,
        ministry, business, or informational purposes and do not copy or post
        such information publicly or otherwise make it publicly available,
        unless Integrity communicates in writing its intent for such information
        to be used in this manner; (3) make no modifications to any such
        information; and (4) not make any additional representations or
        warranties relating to such information.
      </p>
      <Box fontSize="h6.fontSize" fontWeight="bold">
        5. User Content
      </Box>
      <p>
        You are solely responsible for all content created, provided, uploaded,
        linked or posted by you or by any person using a personal account
        registered to, by or on behalf of you (collectively "<u>User Content</u>
        "). You hereby agree:
        <ol type="a">
          <li>
            to comply with the laws of the United States and the state of
            Tennessee, including without limitation laws governing the
            transmission of technical data exported from the United States
            through the Internet and other electronic media;
          </li>
          <li>
            to comply with all posted policies, rules, procedures, and practices
            of Integrity and the Site, including without limitation each
            provision of these Terms of Use;
          </li>
          <li>
            not to disrupt, interfere with, or access without permission
            ("hack") the Site or any website, network, server, system, or
            computer connected thereto;
          </li>
          <li>
            not to use the Site or the name of the Site or Integrity for or in
            connection with chain letters, junk mail, or spamming, and not to
            contact any other user without his or her prior consent;
          </li>
          <li>
            not to create, provide, upload, link, post, or transmit any
            unlawful, harassing, defamatory, libelous, abusive, threatening or
            harmful User Content or information on, to or through the Site;
          </li>
          <li>
            not to create, provide, upload, link, post, or transmit any User
            Content or information on, to or through the Site which encourages
            or incites conduct which gives rise to actual or potential criminal
            or civil liability or violates applicable law; and
          </li>
          <li>
            not to intentionally interfere with the operation of the Site or the
            use and enjoyment thereof by other users or third parties.
          </li>
        </ol>
      </p>
      <Box fontSize="h6.fontSize" fontWeight="bold">
        6. User Conduct
      </Box>
      <p>
        In consideration of Integrity granting you access to the Site, you
        hereby agree that:
        <ol type="a">
          <li>
            You will not attempt to gain unauthorized access to any portion or
            feature of the Site or any other systems or networks connected to
            the Site or to any Integrity server, or to any of the services
            offered on or through the Site, by hacking, password "mining" or any
            other illegitimate means.
          </li>
          <li>
            You will not probe, scan, or test the vulnerability of the Site or
            any network connected to the Site, nor breach the security or
            authentication measures on the Site or any network connected to the
            Site. You may not reverse look-up, trace, or seek to trace any
            information on any other user of or visitor to the Site, including
            any account not owned by you, or exploit the Site or any service or
            information made available or offered by or through the Site.
          </li>
          <li>
            You agree that you will not take any action that imposes an
            unreasonable or disproportionately large load on the infrastructure
            of the Site or Integrity’s systems or networks, or any systems or
            networks connected to the Site or to Integrity.
          </li>
          <li>
            You agree not to use any device, software, or routine to interfere
            or attempt to interfere with the proper working of the Site or any
            transaction being conducted on the Site, or with any other person’s
            use of the Site.
          </li>
          <li>
            You will not forge headers or otherwise manipulate identifiers in
            order to disguise the origin of any message or transmittal you send
            to Integrity or through the Site or any service offered on or
            through the Site. You may not pretend that you are, or that you
            represent, someone else, or impersonate any other individual or
            entity when accessing or otherwise using the Site.
          </li>
          <li>
            You will not use any automatic device, program, algorithm or
            methodology, or any similar or equivalent manual process, to access,
            acquire, copy or monitor any portion of the Site, or in any way
            reproduce or circumvent the navigational structure or presentation
            of the Site, to obtain or attempt to obtain any materials,
            documents, or information through any means not purposely made
            available through the Site. Integrity reserves the right to bar any
            such activity.
          </li>
          <li>
            You may not use the Site or any Content for any purpose that is
            unlawful or prohibited by these Terms, or to solicit the performance
            of any illegal activity or other activity which infringes the rights
            of Integrity or others.
          </li>
        </ol>
      </p>
      <Box fontSize="h6.fontSize" fontWeight="bold">
        7. Access to Site/Violation of Terms
      </Box>
      <p>
        You understand and agree that you are solely responsible for obtaining
        access to the Site, which may involve equipment and third party fees
        (such as internet service provider fees, airtime charges, or other
        charges associated with the display and delivery of electronic
        communications).
      </p>
      <p>
        You agree that Integrity may, for any reason or no reason and without
        prior notice, at Integrity’s sole discretion, immediately terminate your
        account and/or access to the Site at any time and for any reason, and
        shall not be liable to you or any third party for any termination of
        your account or access to the Site. You agree that Integrity will not be
        liable to you or to any third party for termination of your access to
        the Site as a result of any violation of these Terms.
      </p>
      <p>
        Integrity may disclose any information we have about you (including your
        identity) if we determine that such disclosure is necessary in
        connection with any investigation or complaint regarding your use of the
        Site, or to identify, contact, or bring legal action against someone who
        may be causing injury to or interference with (either intentionally or
        unintentionally) Integrity’s rights or property, or the rights or
        property of visitors to or Users of the Site. In addition, if you
        violate the terms of any agreement entered into between you and
        Integrity on the Site, Integrity reserves the right to disclose the
        contents of the agreement in order to enforce its rights. Integrity
        reserves the right at all times to disclose any information that
        Integrity deems necessary to comply with any applicable law, regulation,
        legal process, or governmental request. Integrity also may disclose your
        information when Integrity determines that applicable law requires or
        permits such disclosure, including exchanging information with other
        companies and organizations for fraud protection purposes. To the extent
        that this paragraph conflicts with the Integrity{" "}
        <a href="https://davidccook.org/privacy-policy/" target="_new">
          Privacy Policy
        </a>
        , this paragraph shall govern.
      </p>
      <p>
        You acknowledge and agree that Integrity may preserve any transmittal or
        communication by you with Integrity through the Site or any service
        offered on or through the Site, and may also disclose such data if
        required to do so by law or Integrity determines that such preservation
        or disclosure is reasonably necessary to: (1) comply with legal process;
        (2) enforce these Terms of Use; (3) respond to claims that any such data
        violates the rights of others; or (4) protect the rights, property or
        personal safety of Integrity, its employees, users of or visitors to the
        Site, and the public. This section is in addition to any purposes stated
        in the{" "}
        <a href="https://davidccook.org/privacy-policy/" target="_new">
          Privacy Policy
        </a>
        .
      </p>
      <Box fontSize="h6.fontSize" fontWeight="bold">
        8. Modification of Service
      </Box>
      <p>
        Integrity reserves the sole and exclusive right to change, suspend, or
        terminate the Site and all related services at any time and from time to
        time with or without cause or prior notice. Integrity is not liable to
        you or any third party for any change to, suspension, or termination of
        the Site or related services.
      </p>
      <Box fontSize="h6.fontSize" fontWeight="bold">
        9. Modification of Terms
      </Box>
      <p>
        Should Integrity change any of the Terms above, it will display them on
        the Site. For your convenience and future reference, the date of the
        version of these Terms is set forth below. Your continued use of the
        Site is your consent that you agree to the Terms of Service, so please
        be sure to check back periodically. Please review these Terms frequently
        as Integrity may modify them from time to time. As provided in the
        disclaimer above, only the Terms which you have accepted or that are in
        effect at the time of your use will apply to you.
      </p>
      <Box fontSize="h6.fontSize" fontWeight="bold">
        10. Copyright Claims.
      </Box>
      <p>
        We respect the intellectual property rights of our Users and other third
        parties. If you believe a User has wrongfully posted User Content to the
        Site to which you are the rightful owner, you may send Integrity a
        takedown notice in accordance with the requirements of the Digital
        Millennium Copyright Act. Such notice should be sent to Integrity Music,
        Attn: Legal Department, 4050 Lee Vance Drive, Colorado Springs, CO
        80918, or by email with "DMCA Notice" in the subject line to{" "}
        <a href="mailto:copyright@integritymusic.com">
          copyright@integritymusic.com
        </a>
        .
      </p>
      <Box fontSize="h6.fontSize" fontWeight="bold">
        11. Links to Other Websites
      </Box>
      <p>
        The Site may contain links to other independent third party web sites ("
        <u>Linked Sites</u>"). These Linked Sites are provided solely as a
        convenience to you and our users. Such Linked Sites are not under
        Integrity’s control, and Integrity is not responsible for and does not
        endorse the content of such Linked Sites.
      </p>
      <Box fontSize="h6.fontSize" fontWeight="bold">
        12. Void Where Prohibited
      </Box>
      <p>
        Although the Site is accessible worldwide, not all features, products,
        or services discussed, referenced, provided, or offered through or on
        the Site are available to all persons or in all geographic locations, or
        appropriate or available for use outside the United States. Integrity
        reserves the right to limit, in its sole discretion, the provision and
        quantity of any feature, product, or service to any person or geographic
        area. Any offer for any feature, product, or service made on the Site is
        void where prohibited. If you choose to access the Site from outside the
        United States, you do so on your own initiative and you are solely
        responsible for complying with applicable local laws.
      </p>
      <Box fontSize="h6.fontSize" fontWeight="bold">
        13. Disclaimer
      </Box>
      <p>
        USER AGREES TO USE THE SITE AT USER’S SOLE RISK AND RESPONSIBILITY.
        ACCESS TO THE SITE, RELATED WEBSITES, AND SERVICES IS PROVIDED ON AN
        "AS-IS", "AS- AVAILABLE" BASIS WITH NO EXPRESS OR IMPLIED WARRANTIES OF
        ANY KIND, INCLUDING WITHOUT LIMITATION IMPLIED WARRANTIES OF
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT.
        USER ACKNOWLEDGES THAT A THIRD PARTY TECHNOLOGY PROVIDER, NOT INTEGRITY,
        IS SOLELY RESPONSIBLE FOR THE FUNCTIONALITY OF THE ROYALTY STATEMENT
        PLATFORM SERVICE. INTEGRITY SPECIFICALLY DISCLAIMS ALL EXPRESS, IMPLIED,
        AND STATUTORY WARRANTIES TO THE EXTENT PERMITTED BY APPLICABLE LAW AND
        MAKES NO WARRANTY OR REPRESENTATION THAT THE SITE, RELATED WEBSITES, OR
        SERVICES: (A) WILL MEET THE NEEDS OR REQUIREMENTS OF USER OR WILL BE
        COMPATIBLE WITH ANY HARDWARE, SERVER, SYSTEM, NETWORK, OPERATING SYSTEM,
        SOFTWARE, INTERNET SERVICE PROVIDER, OR OTHER TECHNICAL SPECIFICATIONS;
        (B) WILL BE AVAILABLE, RELIABLE, UNINTERRUPTED, TIMELY, SECURE, OR ERROR
        FREE; (C) WILL PROVIDE OR ENABLE USER TO ACHIEVE A GIVEN OR DESIRED
        RESULT, OR (D) WILL BE REPAIRED, UPGRADED, DEBUGGED, OR FUNCTION WITHOUT
        ERROR, MISTAKE, OR OMISSION. INTEGRITY MAKES NO WARRANTY AND ACCEPTS NO
        RESPONSIBILITY OR LIABILITY FOR CONTENT, INFORMATION, ADVICE, GOODS, OR
        SERVICES PURCHASED OR OBTAINED THROUGH THE SITE, OR RESULTING FROM OR
        ARISING OUT OF THE SITE OR CONTENT. THIS DISCLAIMER OF WARRANTIES MAY
        ONLY BE AMENDED OR MODIFIED BY A WRITTEN INSTRUMENT SIGNED BY AN
        AUTHORIZED REPRESENTATIVE OF INTEGRITY WHICH SPECIFICALLY STATES THAT IT
        MODIFIES THESE TERMS OF USE AND MAY NOT BE ALTERED, MODIFIED, OR
        ELIMINATED IN ANY OTHER MANNER, INCLUDING WITHOUT LIMITATION ADVICE,
        INFORMATION, OR TECHNICAL SUPPORT GIVEN OR RECEIVED FROM INTEGRITY OR
        THE SITE. EXCLUSIONS, LIMITATIONS, AND DISCLAIMERS CONTAINED IN THIS
        DISCLAIMER OF WARRANTIES DO NOT APPLY TO THE EXTENT PROHIBITED BY
        APPLICABLE LAW. THE RIGHTS OF INDIVIDUAL USERS MAY VARY BY JURISDICTION.
      </p>
      <Box fontSize="h6.fontSize" fontWeight="bold">
        14. Indemnity
      </Box>
      <p>
        YOU AGREE TO INDEMNIFY AND HOLD INTEGRITY, ITS OFFICERS, DIRECTORS,
        BOARD MEMBERS, PARENT ORGANIZATIONS, PREDECESSORS, SUCCESSORS IN
        INTEREST, EMPLOYEES, AGENTS, SUBSIDIARIES AND AFFILIATES HARMLESS FROM
        ANY DEMANDS, LOSS, LIABILITY, CLAIMS OR EXPENSES (INCLUDING ATTORNEYS’
        FEES) MADE AGAINST INTEGRITY BY ANY THIRD PARTY DUE TO OR ARISING OUT OF
        OR IN CONNECTION WITH YOUR ACCESS TO OR USE OF THE SITE OR VIOLATION OF
        THESE TERMS.
      </p>
      <Box fontSize="h6.fontSize" fontWeight="bold">
        15. Limitation of Liability
      </Box>
      <p>
        EXCEPT WHERE PROHIBITED BY LAW, IN NO EVENT WILL INTEGRITY BE LIABLE TO
        YOU FOR ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, OR PUNITIVE
        DAMAGES, INCLUDING LOST PROFITS, ARISING OUT OF OR RELATED TO YOUR USE
        OF THE SITE, EVEN IF INTEGRITY HAS BEEN ADVISED OF THE POSSIBILITY OF
        SUCH DAMAGES.
      </p>
      <p>
        IF, NOTWITHSTANDING THE OTHER PROVISIONS OF THESE TERMS, INTEGRITY IS
        FOUND TO BE LIABLE TO YOU FOR ANY DAMAGE OR LOSS WHICH ARISES OUT OF OR
        IS RELATED TO YOUR USE OF THE SITE, INTEGRITY’S LIABILITY SHALL IN NO
        EVENT EXCEED THE GREATER OF: (1) THE TOTAL FEE CHARGED BY INTEGRITY FOR
        ANY PRODUCT, SERVICE, OR FEATURE OF OR ON THE SITE GIVING RISE TO THE
        INITIAL CLAIM MADE AGAINST INTEGRITY, OR (2) U.S. $100.00. SOME
        JURISDICTIONS DO NOT ALLOW LIMITATIONS OF LIABILITY, SO THE FOREGOING
        LIMITATION MAY NOT APPLY TO YOU.
      </p>
      <Box fontSize="h6.fontSize" fontWeight="bold">
        16. Assignment
      </Box>
      <p>
        The license granted to you subject to your compliance with these Terms
        is not assignable and may not be assigned or transferred to any third
        party.
      </p>
      <Box fontSize="h6.fontSize" fontWeight="bold">
        17. Severability and Waiver
      </Box>
      <p>
        If any provision of these Terms is found to be invalid, unenforceable,
        or illegal, the remaining terms and provisions will remain valid and
        enforceable. A waiver of any breach under these Terms will not
        constitute waiver of any rights or future breach and no waiver will be
        binding except in a signed writing.
      </p>
      <Box fontSize="h6.fontSize" fontWeight="bold">
        18. Governing Law
      </Box>
      <p>
        You agree that all matters relating to your access to or use of the
        Site, including all disputes, will be governed by the laws of the United
        States and by the laws of the State of Tennessee without regard to its
        conflicts of law provisions. You agree to the personal jurisdiction by
        and venue in the courts of Davidson County, Tennessee, and waive any
        objection to such jurisdiction or venue. Any claim under these Terms
        must be brought within two (2) years after the cause of action arises,
        or such claim or cause of action is barred. All royalty statements will
        be binding upon and deemed accepted by you two (2) years from the date
        of the statement unless you provide Integrity with a written notice
        identifying any claimed discrepancy. No recovery may be sought or
        received for damages other than out-of-pocket expenses, except that the
        prevailing party will be entitled to costs and attorneys’ fees. In the
        event of any controversy or dispute between Integrity and you arising
        out of or in connection with your use of the Integrity Site, the parties
        shall attempt, promptly and in good faith, to resolve any such dispute.
        If we are unable to resolve any such dispute within a reasonable time
        (not to exceed thirty (30) days), then either party may submit such
        controversy or dispute to mediation. If the dispute cannot be resolved
        through mediation, then the parties shall be free to pursue any right or
        remedy available to them under applicable law.
      </p>
      <Box fontSize="h6.fontSize" fontWeight="bold">
        19. Entire Agreement
      </Box>
      <p>
        Except as otherwise provided herein, these Terms constitute the entire
        agreement of the parties concerning the Site and other matters
        referenced herein and supersede any prior oral or written understandings
        regarding said matters.
      </p>
      <p>Effective: March 31, 2020</p>
    </Box>
  );
}
